// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zwbh","colBig":"styles_colBig__38IwN","colSmall":"styles_colSmall__1Ngm6","shopifyNameWrapper":"styles_shopifyNameWrapper__-DNkG"};